import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RolesState } from '../reducers/roles.reducer';
import { ROLES_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<RolesState>(ROLES_FEATURE_KEY);

export const selectRoles = createSelector(selectState, (state: RolesState) => state.roles);
export const selectLoaded = createSelector(selectState, (state: RolesState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: RolesState) => state.loading);
export const selectQuery = createSelector(selectState, (state: RolesState) => state.query);
export const selectTotal = createSelector(selectState, (state: RolesState) => state.total);
export const selectLookupLoaded = createSelector(selectState, (state: RolesState) => state.lookupLoaded);
export const selectLookup = createSelector(selectState, (state: RolesState) => state.lookup);
export const selectLookupOptions = createSelector(selectLookup, (lookup) => lookup.map((role) => ({ label: role.name, value: role.id })));
